import { Component, Input } from '@angular/core';

/**
 * @docsPrivate
 *
 * @description
 *
 * Componente utilizado para exibiÃ§Ã£o da mensagem customizada de erro em um campo de formulÃ¡rio.
 */
@Component({
  selector: 'thf-modal-password-recovery-error-message',
  templateUrl: './thf-modal-password-recovery-error-message.component.html'
})

export class ThfModalPasswordRecoveryErrorMessageComponent {

  /** Texto exibido na mensagem de erro. */
  @Input('t-text') text: string;

}
